import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient, trpc, trpcClient } from '@/lib/trpc';
import { AstroTRPCProvider } from '@/lib/trpcContext';

/**
 * Internal tRPC provider for Astro standalone app.
 * Uses Firebase auth from @/lib/trpc for authentication.
 *
 * This provider should be used at the app root when running Astro independently.
 * When Astro components are loaded via Module Federation into a host app (e.g., clinic-web),
 * the host app provides its own AstroTRPCProvider with its own auth.
 */
export function AstroInternalTRPCProvider({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <AstroTRPCProvider value={{ trpc, trpcClient }}>
        {children}
      </AstroTRPCProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

// Re-export queryClient for cases where it's needed directly
export { queryClient };
